/**
 * AdminDashboard object represents Dashboard API endpoints and their methods.
 */
const AdminDashboard = {
  /**
   * Endpoint for retrieving dashboard information.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving dashboard information.
   * @property {string} method - The HTTP method for retrieving dashboard information (GET).
   */
  getAdminDashboard: {
    url: "/admin/dashboard",
    method: "GET",
  },
  /**
   * Endpoint for retrieving pie chart information.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving pie chart information.
   * @property {string} method - The HTTP method for retrieving pie chart information (GET).
   */
  getAdminPieChartData: {
    url: "/admin/dashboard/pie-chart",
    method: "GET",
  },

  /**
   * Endpoint for retrieving line graph information.
   * @memberof AdminDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving line graph information.
   * @property {string} method - The HTTP method for retrieving line graph information (GET).
   */
  getAdminLineGraphData: {
    url: "/admin/dashboard/line/graph",
    method: "GET",
  },

};

export default AdminDashboard;
